export class CustomDropdown {
    constructor(container) {
        this.container = container;
        this.button = container.querySelector('.dropdown-toggle');
        this.menu = container.querySelector('.dropdown-menu');
        this.hiddenInput = container.parentElement.querySelector('input[type="hidden"]');
        this.isMultiSelect = container.dataset.multiselect === 'true';
        this.placeholder = this.button.dataset.placeholder || 'Select an option';
        this.items = this.menu.querySelectorAll('.dropdown-item:not(.select-all)');
        this.selectAllItem = this.menu.querySelector('.select-all');
        this.selectedValues = new Set();
        
        this.init();
    }
    
    init() {
        // Prevent dropdown from closing on multi-select
        if (this.isMultiSelect) {
            this.menu.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
        
        // Handle item clicks
        this.items.forEach(item => {
            item.addEventListener('click', (e) => {
                if (this.isMultiSelect) {
                    e.preventDefault();
                    this.toggleItem(item);
                } else {
                    this.selectSingleItem(item);
                }
            });
        });
        
        // Handle select all
        if (this.selectAllItem && this.isMultiSelect) {
            this.selectAllItem.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleAll();
            });
        }
        
        this.updateDisplay();
    }
    
    toggleItem(item) {
        const value = item.dataset.value;
        
        if (this.selectedValues.has(value)) {
            this.selectedValues.delete(value);
            item.classList.remove('selected');
        } else {
            this.selectedValues.add(value);
            item.classList.add('selected');
        }
        
        this.updateDisplay();
        this.updateSelectAll();
    }
    
    selectSingleItem(item) {
        // Clear previous selection
        this.items.forEach(i => i.classList.remove('selected'));
        this.selectedValues.clear();
        
        // Set new selection
        const value = item.dataset.value;
        this.selectedValues.add(value);
        item.classList.add('selected');
        
        this.updateDisplay();
        
        // Close dropdown for single select
        const dropdown = bootstrap.Dropdown.getInstance(this.button);
        if (dropdown) dropdown.hide();
    }
    
    toggleAll() {
        const allSelected = this.selectedValues.size === this.items.length;
        
        if (allSelected) {
            // Deselect all
            this.selectedValues.clear();
            this.items.forEach(item => item.classList.remove('selected'));
        } else {
            // Select all
            this.items.forEach(item => {
                this.selectedValues.add(item.dataset.value);
                item.classList.add('selected');
            });
        }
        
        this.updateDisplay();
        this.updateSelectAll();
    }
    
    updateSelectAll() {
        if (!this.selectAllItem) return;
        
        const allSelected = this.selectedValues.size === this.items.length;
        const someSelected = this.selectedValues.size > 0;
        
        this.selectAllItem.classList.toggle('selected', allSelected);
        
        if (allSelected) {
            this.selectAllItem.textContent = 'Deselect All';
        } else {
            this.selectAllItem.textContent = 'Select All';
        }
    }
    
    updateDisplay() {
        const count = this.selectedValues.size;
        
        if (count === 0) {
            this.button.textContent = this.placeholder;
        } else if (count === 1) {
            const selectedItem = Array.from(this.items).find(item => 
                this.selectedValues.has(item.dataset.value)
            );
            this.button.textContent = selectedItem.textContent;
        } else {
            this.button.textContent = `${count} selected`;
        }
        
        // Update hidden input
        if (this.hiddenInput) {
            if (this.isMultiSelect) {
                this.hiddenInput.value = JSON.stringify(Array.from(this.selectedValues));
            } else {
                this.hiddenInput.value = Array.from(this.selectedValues)[0] || '';
            }
            this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
    
    getSelectedValues() {
        return Array.from(this.selectedValues);
    }
    
    getValue() {
        if (this.isMultiSelect) {
            return this.getSelectedValues();
        } else {
            return Array.from(this.selectedValues)[0] || '';
        }
    }
}